import { Component, Input } from "@angular/core";
import { UntypedFormArray } from "@angular/forms";

import { EntitetStatus } from "@dffedb/util";

import { NoteBilag, NoteBilagPDF } from "../model/note.model";
import { NoteBilagFormBuilder } from "../shared/note-bilag-form-builder";

@Component({
    selector: "note-bilag-liste",
    templateUrl: "./note-bilag-liste.component.html",
    styleUrls: ["./note-bilag-liste.component.scss"]
})
export class NoteBilagListeComponent {
    @Input() public formArray: UntypedFormArray;

    public async onTilfoejBillede(file: HTMLImageElement | NoteBilagPDF): Promise<void> {
        if ((file as NoteBilagPDF).fil && (file as NoteBilagPDF).fil.type === "application/pdf") {
            const pdf = file as NoteBilagPDF;
            const url = URL.createObjectURL(pdf.fil);
            const response = await fetch(url);
            const blob = await response.blob();

            const reader = new FileReader();
            reader.onloadend = () => {
                const base64data = reader.result;

                const noteBilag: NoteBilag = {
                    noteBilagId: 0,
                    filNavn: (file as NoteBilagPDF).filNavn,
                    filStoerrelseKb: 0, // Beregnes på serveren
                    url: base64data as string,
                    status: EntitetStatus.Tilfoejet
                };
                const noteBilagFormGroup = NoteBilagFormBuilder.bilagToFormGroup(noteBilag);
                this.formArray.push(noteBilagFormGroup);
            };
            reader.readAsDataURL(blob);
        } else if ((file as HTMLImageElement).src) {
            const imageSrc = file as HTMLImageElement;
            const noteBilag: NoteBilag = {
                noteBilagId: 0,
                filNavn: imageSrc.title,
                filStoerrelseKb: 0, // Beregnes på serveren
                url: imageSrc.src,
                status: EntitetStatus.Tilfoejet
            };
            const noteBilagFormGroup = NoteBilagFormBuilder.bilagToFormGroup(noteBilag);
            this.formArray.push(noteBilagFormGroup);
        } else {
            alert("Kun billeder og PDF'er kan tilføjes som bilag.");
        }
    }
}
